module.exports = __webpack_public_path__ + "phabricator-logo.png";